/** Injected by Vite from package.json, so the audit block cannot claim a stale version. */
declare const __APP_VERSION__: string

export const APP_VERSION = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0-dev'

/**
 * A short description of what the form was signed on, for the audit block.
 *
 * A full user-agent string is long, noisy and largely fiction. The high-entropy
 * client hints are better but need an async call, so this uses whatever is
 * available synchronously and falls back to the raw agent.
 */
export function deviceDescription(): string {
  if (typeof navigator === 'undefined') return 'unknown device'
  const data = (navigator as Navigator & { userAgentData?: { platform?: string; brands?: { brand: string; version: string }[] } })
    .userAgentData
  if (data?.platform) {
    const brand = data.brands?.find((b) => !/Not.?A.?Brand/i.test(b.brand))
    return brand ? `${data.platform}, ${brand.brand} ${brand.version}` : data.platform
  }
  return navigator.userAgent.slice(0, 120)
}
